import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
// styles
import 'eiq-storybook/build/styles/css/index.css';
import 'font-awesome/css/font-awesome.css';
import 'src/styles/app.css';
import App from 'src/pages/App';
import getEnv from 'src/utils/api/env';
// eslint-disable-next-line
import { default as data } from '../package.json';


const devEnviorment = ['STAGING', 'DEV', 'PROD', 'ONBOARD'];
const envCatch = getEnv();
if ( devEnviorment.includes(envCatch) && window.location.hostname !== "localhost" ) {
  Sentry.init({
    ignoreErrors:[
      "Can't find variable: zaloJSV2",
      "zaloJSV2 is not defined",
      "Unhandled zaloJSV2 is not defined",
    ],
    environment: envCatch,
    dsn: 'https://a0c5415fc6564499b4c3cb6265b75063@o1120419.ingest.sentry.io/6202666',
    integrations: [new Sentry.BrowserTracing()],// Set tracesSampleRate to 1.0 to capture 100%// of transactions for performance monitoring.// We recommend adjusting this value in production
    tracesSampleRate: 0,
    release: `eiq-assess-web-${data.version}`
  });
}

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<App />);
